import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { CreditBillReciptMstData, CreditBillReciptMst } from '../../../interfaces/pharmacy/CreditBillReceiptMst';

@Injectable()
export class CreditBillReciptApi {
  private readonly apiController: string = 'CreditBillReciptMst'; 

  constructor(private api: HttpService) { }

  getall(url: string, options?: any): Observable<any[]> { 
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  getby_id(url : string, options?: any): Observable<any> { 
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  add(url:string, data: CreditBillReciptMst):Observable<CreditBillReciptMst[]>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post( url, data, header);
  }

  searchList(url: string, data:any, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.post(url,data,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

}